"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenuePicker = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const PhoneIphone_1 = __importDefault(require("@mui/icons-material/PhoneIphone"));
const Laptop_1 = __importDefault(require("@mui/icons-material/Laptop"));
const localeHelper_1 = require("../../../common/helpers/localeHelper");
const services_1 = require("../../../common/services");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const VenuePickerWrapper = styled_components_1.default.div `
  width: 100%;
  padding: 16px;
  padding-top: 30vmin;
`;
const VenueSearchContainer = styled_components_1.default.div `
  width: 100%;
  margin-bottom: 10vmin;
`;
const VenuePicker = (props) => {
    const [initialVenue, setInitialVenue] = (0, react_1.useState)({});
    const [venues, setVenues] = (0, react_1.useState)([]);
    const [selectedLocales, setSelectedLocales] = (0, react_1.useState)([]);
    const [mode, setMode] = (0, react_1.useState)("interactive");
    const [votingEnabled, setVotingEnabled] = (0, react_1.useState)(false);
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const [controls, setControls] = (0, react_1.useState)("controlsOff");
    const openWindow = (type, params) => {
        if (!initialVenue) {
            return;
        }
        const kioskEnabled = window.location.search.includes("kioskEnabled");
        const { brandSlug, slug } = initialVenue;
        let locales = "";
        selectedLocales.map((locale) => (locales = `${locales}&locale=${locale}`));
        const kioskSlug = kioskEnabled ? "&kioskEnabled" : "";
        const controlsValue = controls === "controlsOn" ? "&controls=true" : "";
        const newLocation = `/${brandSlug}/${slug}/${votingEnabled ? "voting/" : ""}overview?daysToFetch=3&mode=${mode}${locales}${kioskSlug}${controlsValue}`;
        window.open(newLocation, type, params.join(","));
    };
    const openInLandscape169Ratio = (event) => {
        event.preventDefault();
        const params = [
            `height=${(window.screen.width - 50) * (1080 / 1920)}`,
            `width=${window.screen.width - 50}`,
        ];
        openWindow("popup_window", params);
    };
    const openInLandscape43Ratio = (event) => {
        event.preventDefault();
        const params = [`height=${748}`, `width=${1004}`];
        openWindow("popup_window", params);
    };
    const openInCurrentWindow = (event) => {
        event.preventDefault();
        openWindow("_self", []);
    };
    const handleControlsChange = (event) => {
        setControls(event.target.value);
    };
    const openInPortrait = (event) => {
        event.preventDefault();
        const params = [
            `height=${window.screen.height - 80}`,
            `width=${(window.screen.height - 80) * (1080 / 1920)}`,
        ];
        openWindow("popup_window", params);
    };
    const handleModeChange = (event) => {
        setMode(event.target.value);
        if (event.target.value === "interactive") {
            setControls("controlsOff ");
        }
    };
    const handleAutocomplete = (event, value) => {
        const foundVenue = venues.find((venue) => venue.title === value);
        if (foundVenue) {
            setInitialVenue(foundVenue);
            setVotingEnabled(votingEnabled);
        }
    };
    const sortVenues = (venuesList) => venuesList.sort((firstVenue, secondVenue) => firstVenue.title.localeCompare(secondVenue.title));
    const extractVenueNames = () => sortVenues(venues).map((venue) => venue.title);
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        const venueList = yield services_1.apiService.getVenues();
        setTimeout(() => {
            const radioForInteractive = document.getElementById("interactive");
            if (radioForInteractive) {
                radioForInteractive.setAttribute("checked", "true");
            }
        }, 100);
        setInitialVenue(venueList[0]);
        setVenues(venueList);
        setIsLoaded(true);
    });
    (0, react_1.useEffect)(() => {
        initialSetup();
    }, []);
    const renderLocaleSelector = () => {
        if (initialVenue) {
            return initialVenue.enabledLocales.map((locale) => localeHelper_1.localeNames[locale] && (react_1.default.createElement(material_1.FormControlLabel, { key: locale, value: "end", control: react_1.default.createElement(material_1.Checkbox, { onChange: (e) => {
                        if (e.target.checked) {
                            setSelectedLocales([...selectedLocales, locale]);
                        }
                        else {
                            selectedLocales.splice(selectedLocales.indexOf(locale), 1);
                            setSelectedLocales(selectedLocales);
                        }
                    } }), label: localeHelper_1.localeNames[locale], labelPlacement: "end" })));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    if (!isLoaded) {
        return (react_1.default.createElement("div", { className: "overlay" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    return (react_1.default.createElement(VenuePickerWrapper, null,
        react_1.default.createElement(VenueSearchContainer, null,
            react_1.default.createElement(material_1.Autocomplete, { disablePortal: true, id: "combo-box-demo", options: extractVenueNames(), sx: { width: "100%" }, renderInput: (params) => (react_1.default.createElement(material_1.TextField, Object.assign({}, params, { label: "Select Venue" }))), defaultValue: initialVenue.title, noOptionsText: "No matches", onChange: handleAutocomplete })),
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(material_1.RadioGroup, { row: true, "aria-label": "interactivity", defaultValue: "interactive", name: "row-radio-buttons-group" },
                        react_1.default.createElement(material_1.FormControlLabel, { value: "interactive", control: react_1.default.createElement(material_1.Radio, { onChange: handleModeChange }), label: "Interactive" }),
                        react_1.default.createElement(material_1.FormControlLabel, { value: "linear", control: react_1.default.createElement(material_1.Radio, { onChange: handleModeChange }), label: "Linear" })))),
            mode === "linear" && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.RadioGroup, { name: "row-radio-buttons-group" },
                    react_1.default.createElement(material_1.FormControlLabel, { value: "controlsOff", control: react_1.default.createElement(material_1.Radio, { onChange: handleControlsChange }), label: "Controls OFF" }),
                    react_1.default.createElement(material_1.FormControlLabel, { value: "controlsOn", control: react_1.default.createElement(material_1.Radio, { onChange: handleControlsChange }), label: "Controls ON" })))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, "Locales"),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(material_1.FormGroup, { "aria-label": "position", row: true }, renderLocaleSelector()))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInPortrait, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(PhoneIphone_1.default, null) }, "Portrait")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInLandscape169Ratio, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(Laptop_1.default, null) }, "Landscape (16:9)")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInLandscape43Ratio, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(Laptop_1.default, null) }, "Landscape (4:3)")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInCurrentWindow, variant: "contained", size: "large", fullWidth: true }, "Current window")))));
};
exports.VenuePicker = VenuePicker;
exports.default = exports.VenuePicker;
